import { DIGITAL_LOAN_STEPS } from 'constants/digitalLoan';
import {
  PHASE4_BACKEND_PHASE,
  PHASE4_BACKEND_STEPS,
} from 'constants/digitalLoanPhase4';

/** Pasos de ruta de Fase 4a. El desembolso no tiene pantalla. */
export const PHASE4_FE_STEPS = Object.freeze([
  DIGITAL_LOAN_STEPS.FINAL_OFFER,
  DIGITAL_LOAN_STEPS.CLABE,
  DIGITAL_LOAN_STEPS.BIOMETRIC_FINAL,
  DIGITAL_LOAN_STEPS.CONTRACT_GENERATION,
  DIGITAL_LOAN_STEPS.OPERATIONAL_WINDOW,
  DIGITAL_LOAN_STEPS.CONTRACT_READY,
]);

/**
 * Traduce un currentStep de contratación a pantalla.
 * null si el paso no es uno de los estados posteriores reconocidos.
 */
export function screenForPhase4Step(currentStep) {
  switch (currentStep) {
    case PHASE4_BACKEND_STEPS.OFFER_ACCEPTED:
      return DIGITAL_LOAN_STEPS.CLABE;
    case PHASE4_BACKEND_STEPS.CLABE_VALIDATED:
      return DIGITAL_LOAN_STEPS.BIOMETRIC_FINAL;
    case PHASE4_BACKEND_STEPS.BIOMETRIC_FINAL:
      return DIGITAL_LOAN_STEPS.CONTRACT_GENERATION;
    case PHASE4_BACKEND_STEPS.PENDING_OPERATIONAL_WINDOW:
      return DIGITAL_LOAN_STEPS.OPERATIONAL_WINDOW;
    case PHASE4_BACKEND_STEPS.CONTRACT_GENERATED:
      return DIGITAL_LOAN_STEPS.CONTRACT_READY;
    default:
      return null;
  }
}

export function isPhase4FeStep(step) {
  return PHASE4_FE_STEPS.includes(step);
}

/**
 * Reentrada de Fase 4a. currentStep gana sobre la visita de Fase 3.
 * Devuelve null si la solicitud sigue en Fase 3 sin cierre.
 */
export function resolvePhase4Entry({
  currentStep,
  currentPhase,
  status,
} = {}) {
  if (status?.hasApplicationAwaitingDisbursement === true) {
    return DIGITAL_LOAN_STEPS.CONTRACT_READY;
  }

  const app = status?.activeApplication || {};
  const step = currentStep || app.currentStep || null;
  const phase = currentPhase || app.currentPhase || null;
  const knownScreen = screenForPhase4Step(step);
  if (knownScreen) return knownScreen;

  if (phase === PHASE4_BACKEND_PHASE) {
    return DIGITAL_LOAN_STEPS.FINAL_OFFER;
  }

  return null;
}

/** Fase 3 ya cerró: no volver a la visita. */
export function isPhase3Closed(status) {
  return Boolean(status?.gestoria?.completedAt);
}
